import { shallowMount } from "@vue/test-utils";
import Paso3 from "@/views/Paso3";

describe("Paso3 component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Paso3, { stubs: ["custom-input-groupASO"] });
  });

  it("Renders del component Paso3", () => {
    expect(wrapper).toBeDefined();
  });
});
